// Device type breakpoints (match your app's breakpoints)
const MOBILE_MAX = 767;
const TABLET_MAX = 1023;

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

// SSR: Detect device type from user agent
export function getDeviceTypeFromUA(userAgent?: string): DeviceType {
  if (!userAgent) return 'desktop';
  const ua = userAgent.toLowerCase();
  if (/mobile|android|iphone|ipod|blackberry|iemobile|opera mini/.test(ua)) {
    return 'mobile';
  }
  if (/ipad|tablet|kindle|playbook|silk/.test(ua)) {
    return 'tablet';
  }
  return 'desktop';
}

// CSR: Detect device type from window width
export function getDeviceTypeFromWidth(width: number): DeviceType {
  if (width <= MOBILE_MAX) return 'mobile';
  if (width <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

// Universal utility: SSR (userAgent) or CSR (window)
export function getDeviceType(userAgent?: string): DeviceType {
  if (typeof window === 'undefined') {
    // SSR
    return getDeviceTypeFromUA(userAgent);
  } else {
    // CSR
    return getDeviceTypeFromWidth(window.innerWidth);
  }
}